import { ApiRequestPayload, apiCall, apiRequestDefaultPayload } from '..';

export const findArticleFields = (articleId: number, successActionName: string) => {
  const requestPayload: ApiRequestPayload = {
    ...apiRequestDefaultPayload,
    url: `/api/crm/articles/${articleId}/fields`,
    onSuccess: successActionName,
  };
  return apiCall(requestPayload);
};
